import React from 'react';
import c from 'classnames';

import {
  Icon,
  Image,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { SCREEN_NORMAL, SCREEN_WIDE } from '../../../../config/constants';
import useBubble from '../../../../helpers/useBubble';

import './style.scss';

type Props = {
  title: string,
  subtitle?: string,
  link: string,
  labelLinkTitle: string,
  imageUrl: string[],
  titleClassName?: string,
};

const LinkListPrimaryItem: React.FC<Props> = (props) => {
  const {
    title,
    subtitle,
    link,
    imageUrl,
    labelLinkTitle,
    titleClassName,
  } = props;

  const titleClasses = c('LinkListItemHomepage__title', titleClassName);
  const classes = c('LinkListItemHomepage');
  const { width } = useWindowDimensions();
  const isTablet = width < SCREEN_NORMAL;
  const isNormal = width < SCREEN_WIDE;

  const {
    BubbleComponent,
    parentRef,
    onEnter,
    onLeave,
  } = useBubble();

  // @ts-ignore
  const enter = (event) => {
    onEnter(event);
  };

  // @ts-ignore
  const leave = (event) => {
    onLeave(event);
  };

  return (
    <div
      // @ts-ignore
      ref={parentRef}
      className={classes}
      onMouseEnter={enter}
      onMouseLeave={leave}
      onFocus={enter}
      onBlur={leave}
    >
      <CoreLink href={link} title={title} className="LinkListItemHomepage__link">
        {!isTablet && (<BubbleComponent />)}

        <div className="LinkListItemHomepage__image">
          <Image src={imageUrl} alt={title} lazyload={false} />
        </div>

        <div className="LinkListItemHomepage__content">
          {isNormal ? (
            <>
              <div className={titleClasses}>
                <Icon name="format_quote" />
                <h2>{title}</h2>
              </div>
              <div className="LinkListItemHomepage__label">
                {/* @ts-ignore */}
                <CoreLink className="LinkListItemHomepage__label__link" href={link} tabIndex={-1}>{labelLinkTitle}<Icon name="arrow_forward" /></CoreLink>
              </div>
            </>

          ) : (
            <>
              <div className={titleClasses}>
                <Icon name="format_quote" />
                <h2>{title}</h2>
              </div>
              <div className="LinkListItemHomepage__subtitle">
                <span className="LinkListItemHomepage__subtitle__text">{subtitle}</span>
                <div className="LinkListItemHomepage__label">
                  {/* @ts-ignore */}
                  <CoreLink className="LinkListItemHomepage__label__link" href={link} tabIndex={-1}>{labelLinkTitle}<Icon name="arrow_forward" /></CoreLink>
                </div>
              </div>
            </>
          )}
        </div>
      </CoreLink>
    </div>
  );
};

export default LinkListPrimaryItem;
